import { Tabs } from "antd";
import { useState } from "react";
import { useHistory, useParams } from "react-router";
import DesignScopeLevelOfDetailSettings from "./design-scope-level-of-detail-settings";

function DesignScopeSettings(props: { disabled: boolean }) {
  const { disabled } = props;
  const history = useHistory();
  const { projectId, tab3Id } = useParams() as any;
  const [selectedTab, setSelectedTab] = useState<string>(
    tab3Id && tab3Id !== "rename-fields" ? tab3Id : "level-of-detail"
  );

  const tabItems = [
    {
      label: (
        <span className="pl-2.5" data-testid="design-scope-level-of-detail">
          Level of Detail
        </span>
      ),
      key: "level-of-detail",
      children: (
        <DesignScopeLevelOfDetailSettings disabled={disabled} scope="project" />
      )
    }
  ];

  return (
    <div className="w-full bg-ciq-white h-full module-settings--tabs">
      <Tabs
        tabPlacement="start"
        tabBarGutter={2}
        tabBarStyle={{ width: "180px" }}
        activeKey={selectedTab}
        items={tabItems}
        onChange={(activeKey) => {
          history.push(
            `/project/${projectId}/settings/modules/design-scope/${activeKey.toString()}`
          );
          setSelectedTab(activeKey);
        }}
        destroyOnHidden
      />
    </div>
  );
}

export default DesignScopeSettings;
